<script setup lang="ts">
defineProps<{
  isLoading: boolean
  hasAllResultsLoaded: boolean
}>()
</script>

<template>
  <ul class="pb-6">
    <li v-if="isLoading" class="flex justify-center p-4">
      <UiLoading class="text-secondary h-8" />
    </li>
    <li v-else-if="!hasAllResultsLoaded">
      <div class="border-t border-neutral-100 px-4 pt-4 text-center">
        <p class="body-2 text-neutral-700">Scroll down to load more...</p>
      </div>
    </li>
    <li v-else>
      <div class="border-t border-neutral-100 px-4 pt-4 text-center">
        <p class="body-2 text-neutral-700">
          You have reached the end of the results.
        </p>
      </div>
    </li>
  </ul>
</template>
